import { vulnerability } from './rules.js';
function perTrick(strain) {
    return strain === 'C' || strain === 'D' ? 20 : 30;
}
/** The contract's own trick score, before overtricks. */
export function trickScore(c) {
    const base = c.strain === 'NT' ? 40 + 30 * (c.level - 1) : perTrick(c.strain) * c.level;
    return base * (c.doubled === 2 ? 4 : c.doubled === 1 ? 2 : 1);
}
/** Rules §2.6: 50/100 a trick undoubled; doubled 100-200-200-300… non-vulnerable
 *  and 200-300-300-300… vulnerable; redoubled twice that. */
export function undertrickPenalty(down, doubled, vul) {
    if (doubled === 0)
        return down * (vul ? 100 : 50);
    let total = 0;
    for (let i = 1; i <= down; i++) {
        total += vul ? (i === 1 ? 200 : 300) : i === 1 ? 100 : i <= 3 ? 200 : 300;
    }
    return doubled === 2 ? total * 2 : total;
}
export function scoreContract(c, tricks, vul) {
    const need = c.level + 6;
    if (tricks < need) {
        const down = need - tricks;
        const penalty = undertrickPenalty(down, c.doubled, vul);
        return { total: -penalty, lines: [{ text: `Down ${down}`, points: penalty }] };
    }
    const lines = [];
    const ts = trickScore(c);
    lines.push({ text: `${c.label} made`, points: ts });
    if (ts >= 100)
        lines.push({ text: vul ? 'Game, vulnerable' : 'Game', points: vul ? 500 : 300 });
    else
        lines.push({ text: 'Part score', points: 50 });
    if (c.level === 6)
        lines.push({ text: 'Small slam', points: vul ? 750 : 500 });
    if (c.level === 7)
        lines.push({ text: 'Grand slam', points: vul ? 1500 : 1000 });
    if (c.doubled === 1)
        lines.push({ text: 'Doubled, made', points: 50 });
    if (c.doubled === 2)
        lines.push({ text: 'Redoubled, made', points: 100 });
    const over = tricks - need;
    if (over > 0) {
        const each = c.doubled === 0 ? perTrick(c.strain) : (vul ? 200 : 100) * c.doubled;
        lines.push({ text: over === 1 ? 'Overtrick' : `${over} overtricks`, points: over * each });
    }
    return { total: lines.reduce((n, l) => n + l.points, 0), lines };
}
export function bridgeScoreHand(hand, table, config) {
    const tricksBySeat = Array.from({ length: table.seatCount }, () => 0);
    for (const t of hand.tricks)
        if (t.winner !== null)
            tricksBySeat[t.winner] += 1;
    const deltas = table.teams.map(() => 0);
    const contract = hand.contract;
    if (!contract) {
        return { deltas, tricksBySeat, contractMade: null, lines: [], matchExtra: {} };
    }
    const side = table.teamOf[contract.declarer];
    const other = table.teams.find((t) => t.id !== side).id;
    const taken = table.teams[side].seats.reduce((n, s) => n + tricksBySeat[s], 0);
    const vul = vulnerability(hand.index, hand.dealer, table.seatCount, config)[side];
    const score = scoreContract(contract, taken, vul);
    const team = score.total >= 0 ? side : other;
    deltas[team] = Math.abs(score.total);
    return {
        deltas,
        tricksBySeat,
        contractMade: score.total >= 0,
        lines: score.lines.map((l) => ({ team, text: l.text, points: l.points })),
        matchExtra: {},
    };
}
/** After the configured number of boards, the higher total wins. */
export function bridgeMatchEnd(state, config) {
    if (state.handHistory.length < config.boards)
        return { finished: false };
    const [a, b] = state.scores;
    const winningTeam = a === b ? null : a > b ? 0 : 1;
    return {
        finished: true,
        winningTeam,
        reason: `${config.boards} board${config.boards === 1 ? '' : 's'} played`,
    };
}
//# sourceMappingURL=scoring.js.map